{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "A Chrome-bővítmény nincs telepítve.",
      "CTA": "Bővítmény telepítése"
    },
    "STATUS": {
      "OFFLINE": "Telefon offline",
      "IN_OTHER_TAB": "A telefon egy másik lapon csatlakozott",
      "CONNECTING": "Csatlakozás...",
      "DISCONNECTING": "Leválasztás...",
      "ONLINE": "Telefon online",
      "DIALING": "Tárcsázás",
      "TRANSFERRING": "Átadás folyamatban...",
      "CONSULTING": "Beszélgetés a kollégával",
      "CALLER_ON_HOLD": "A hívó tartásban van",
      "BUSY": "Foglalt",
      "DND": "DND",
      "UNAVAILABLE": "Nem elérhető",
      "REJECTED": "Hívás elutasítva",
      "CALL_FAILED": "Hívás sikertelen"
    },
    "QUEUES": {
      "MORE": "További sorok"
    },
    "TABS": {
      "PHONE": "Telefon",
      "SMS": "SMS",
      "HISTORY": "Előzmények"
    },
    "HISTORY": {
      "OPEN": "Megnyitás",
      "RECENT": "Legutóbbi",
      "MISSED": "Elmulasztott",
      "LOADING": "Hívások betöltése...",
      "EMPTY": "Nincsenek itt hívások",
      "ERROR": "Nem sikerült betölteni a hívásokat",
      "CALL": "Visszahívás",
      "CALL_STATUS": {
        "BUTTON": "Hívásállapot beállítása",
        "TITLE": "Hívásállapot",
        "SEARCH_PLACEHOLDER": "Állapotok keresése...",
        "LOADING": "Állapotok betöltése...",
        "NO_OPTIONS": "Nincsenek beállítva hívásállapotok",
        "NO_MATCH": "Nincs egyező állapot",
        "OPTIONS_ERROR": "Nem sikerült betölteni az állapotokat",
        "RETRY": "Próbáld újra",
        "CONFIRM_QUESTION": "Beállítja a(z) „{status}” állapotot, és megoldja a beszélgetést?",
        "CONFIRM": "Megerősítés",
        "BACK": "Vissza",
        "CANCEL": "Mégse",
        "SAVING": "Mentés...",
        "SAVE_ERROR": "Nem sikerült menteni az állapotot",
        "RESOLVE_ERROR": "Az állapot elmentve, de a beszélgetést nem sikerült megoldani"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Telefonszám, pl. +421903000000",
      "BODY_PLACEHOLDER": "Írja meg az üzenetet...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "SMS küldése",
      "SENDING": "Küldés...",
      "SENT": "SMS elküldve",
      "LOADING": "SMS postafiókok betöltése...",
      "NO_INBOX": "Ehhez a fiókhoz nincs SMS postafiók, ezért nem küldhető SMS.",
      "INVALID_NUMBER": "Adja meg a számot nemzetközi formátumban, a kezdő + jellel együtt.",
      "ERROR": "Az SMS-t nem sikerült elküldeni. Kérjük, próbálja újra."
    },
    "ACTIONS": {
      "CONNECT": "Csatlakozás",
      "GO_TO_TAB": "Ugrás arra a lapra",
      "DISCONNECT": "Leválasztás",
      "ANSWER": "Fogadás",
      "HANGUP": "Hívás befejezése",
      "HOLD": "Tartás",
      "MUTE": "Mikrofon némítása",
      "SILENCE": "Hang elnémítása",
      "TRANSFER": "Átadás",
      "COMPLETE_TRANSFER": "Átadás befejezése",
      "RETURN_TO_CALLER": "Vissza a hívóhoz",
      "CANCEL_TRANSFER": "Átadás megszakítása",
      "DIALPAD": "Tárcsázó megjelenítése",
      "OPEN_CONVERSATION": "Beszélgetés megnyitása"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Bejövő hívás",
      "INCOMING_CALL_FROM": "Bejövő hívás tőle: {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Bejövő hívás a következő számról: {number}",
      "ANSWER": "Fogadás",
      "DECLINE": "Elutasítás"
    },
    "TRANSFER": {
      "TITLE": "Hívás átadása",
      "PLACEHOLDER": "Adja meg az átadás célszámát...",
      "SEARCH_PLACEHOLDER": "Ügynökök keresése...",
      "TARGET_PLACEHOLDER": "Kiválasztott átadási cél",
      "CONFIRM": "Átadás",
      "MODE_DIRECT": "Átadás azonnal",
      "MODE_CONSULT": "Először a kolléga hívása",
      "CANCEL": "Mégse"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Biztosan szünetet szeretne tartani az összes sorban?",
      "CONFIRM_READY": "Biztosan vissza szeretne térni a kész állapotba az összes sorban?",
      "CONFIRM_BREAK_QUEUE": "Biztosan ki szeretne jelentkezni a(z) {queue} sorból?",
      "CONFIRM_READY_QUEUE": "Biztosan be szeretne jelentkezni a(z) {queue} sorba?",
      "LOGIN_TO_QUEUE": "Bejelentkezés",
      "LOGOUT_FROM_QUEUE": "Kijelentkezés",
      "LOGIN_TO_ALL_QUEUES": "Bejelentkezés minden sorba",
      "LOGOUT_FROM_ALL_QUEUES": "Kijelentkezés minden sorból",
      "OPTION_LOGOUT": "Kijelentkezés",
      "OPTION_BREAK": "Szünet",
      "OPTION_LUNCH": "Ebéd",
      "OPTION_AWAY": "Távol",
      "OPTION_DO_NOT_DISTURB": "Ne zavarjanak",
      "OPTION_BUSINESS_TRIP": "Üzleti út",
      "CONFIRM": "Megerősítés",
      "CANCEL": "Mégse"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Nincs kapcsolat a telefonrendszerrel",
      "MESSAGE": "Úgy tűnik, az internetkapcsolata nem működik. Kérjük, ellenőrizze, és próbálja újra.",
      "CREDENTIALS_TITLE": "A telefonrendszer elutasította a hitelesítő adatait",
      "CREDENTIALS_MESSAGE": "A telefonrendszer elutasította a profiljában mentett felhasználónevet vagy jelszót. Ellenőrizze őket a Profilbeállításokban, vagy forduljon a rendszergazdához.",
      "CONFIGURATION_TITLE": "A telefonbeállítások érvénytelenek",
      "CONFIGURATION_MESSAGE": "A SIP felhasználónév vagy a szerver címe érvénytelen formátumú, ezért a telefon nem tud csatlakozni. Javítsa ki a Profilbeállításokban.",
      "NETWORK_SHORT": "Kapcsolat sikertelen",
      "CREDENTIALS_SHORT": "Hitelesítő adatok elutasítva",
      "CONFIGURATION_SHORT": "Érvénytelen telefonbeállítások",
      "RETRY": "Próbáld újra",
      "DISMISS": "Mégse"
    },
    "CONNECTION_QUALITY": "Kapcsolat minősége",
    "CONNECTION_QUALITY_EXCELLENT": "Kiváló",
    "CONNECTION_QUALITY_GOOD": "Jó",
    "CONNECTION_QUALITY_FAIR": "Megfelelő",
    "CONNECTION_QUALITY_POOR": "Gyenge",
    "CONNECTION_QUALITY_DISCONNECTED": "Nincs kapcsolat"
  },
  "DIAL_REDIRECT": {
    "DIALING": "Tárcsázás: {number}… Bezárhatja ezt a lapot.",
    "NO_NUMBER": "Nincs megadva szám. Használja a ?number=+420... paramétert"
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Adja meg a telefonszámot...",
    "ACTIONS": {
      "DIAL": "Szám tárcsázása",
      "DIAL_FROM": "Válassza ki a hívó számot"
    },
    "DIAL_FROM": {
      "TITLE": "Hívás a fiók számáról"
    },
    "VALIDATION": {
      "REQUIRED": "A telefonszám megadása kötelező",
      "INVALID_FORMAT": "Érvénytelen telefonszám formátum"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Hangbeállítások és tesztelés",
    "SELECT_DEVICE": "Eszköz kiválasztása...",
    "SYSTEM_DEFAULT": "Rendszer alapértelmezett",
    "SAVED": "Mentve",
    "DISCONNECTED_SUFFIX": "nincs csatlakoztatva",
    "DEVICE_DISCONNECTED": "A kiválasztott eszköz nincs csatlakoztatva. A hívások a rendszer alapértelmezett eszközét használják, amíg vissza nem tér.",
    "MICROPHONE": {
      "TITLE": "Mikrofon",
      "START_TEST": "Mikrofon tesztelése",
      "STOP_TEST": "Teszt leállítása",
      "LEVEL": "Szint:",
      "VERDICT": {
        "LISTENING": "Mondjon valamit a mikrofonba…",
        "SILENT": "Nem hallják Önt. Ellenőrizze, hogy a mikrofon be van-e kapcsolva, és a megfelelő van-e kiválasztva.",
        "LOW": "Csak halkan hallják Önt. Válasszon másik mikrofont, vagy állítsa be a bemeneti hangerőt a rendszerbeállításokban.",
        "GOOD": "Jó hang — jól hallják Önt."
      }
    },
    "SPEAKER": {
      "TITLE": "Hangszóró",
      "TEST": "Hangszóró tesztelése",
      "TESTING": "Tesztelés...",
      "VOLUME": "Hangerő:",
      "USING_DEFAULT": "A kiválasztott kimenet nem érhető el — a rendszer alapértelmezett eszközén szólt."
    },
    "DONE": "Kész",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Hiba a mikrofon elérésekor. Ellenőrizze az engedélyeket.",
      "MICROPHONE_PERMISSION_DENIED": "A mikrofonhoz való hozzáférés le van tiltva. Engedélyezze a böngésző webhelybeállításaiban a telefon használatához.",
      "MICROPHONE_SILENT": "A mikrofonja nem érzékel hangot. Ellenőrizze a hangbeállításokat.",
      "EXTENSION_REQUIRED": "A telefon-bővítmény nem található. Telepítse vagy engedélyezze a mikrofon használatához.",
      "SPEAKER_TEST": "Hiba a hangszóró tesztelésekor."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "BUSY": "Foglalt"
  },
  "QUEUE_STATUS": {
    "READY": "Kész",
    "NOT_READY": "Nem fogad hívásokat",
    "WRAP_UP": "Utómunka",
    "BREAK": "Szünet",
    "LUNCH": "Ebédszünet",
    "AWAY": "Távol",
    "DO_NOT_DISTURB": "Ne zavarjanak",
    "BUSINESS_TRIP": "Üzleti út",
    "OTHER_CALL": "Egyéb hívás",
    "QUEUE_CALL": "Sor hívás",
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "NO_ACCESS": "Nincs telefon",
    "PARTIALLY_READY": "Részben kész",
    "MIXED": "Vegyes",
    "CHAT_ONLINE": "Online (chat)",
    "CHAT_BUSY": "Elfoglalt (chat)",
    "CHAT_OFFLINE": "Offline (chat)"
  }
}
